import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Session from 'supertokens-auth-react/recipe/session';

import { useApiClient } from '@eluve/api-client-provider';
import { Button, Heading, LinkButton, Stack, Text } from '@eluve/components';
import {
  useIsEluveAdmin,
  useSession,
  useTenantIdFromSession,
} from '@eluve/session-helpers';
import { getCoreTenantDataQuery } from '@eluve/shared-gql-operations';

export const PendingApprovalPage: React.FC = () => {
  const apiClient = useApiClient();
  const tenantId = useTenantIdFromSession();
  const isEluveAdmin = useIsEluveAdmin();
  const session = useSession();
  const hasMultipleTenants = session.allowedTenantIds.length > 1;

  const [query] = useLazyQuery(getCoreTenantDataQuery);

  const navigate = useNavigate();

  const handleRetry = async () => {
    await apiClient.auth.refreshAllowedTenants();
    if (tenantId) {
      const { data } = await query({ variables: { tenantId } });
      if ((data?.tenantsByPk?.isPendingApproval ?? true) === false) {
        navigate('/');
      }
    }
  };

  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <Heading
          size="3xl"
          weight="bold"
          level={1}
          className="mt-4 tracking-tight sm:text-[3rem]/14 sm:leading-14"
        >
          Account Pending
        </Heading>
        <Text size="md" color="tertiary" className="mt-6 leading-7">
          Thank you for signing up! Your account is pending email verification.
        </Text>
        <Stack
          justify="center"
          align="center"
          className="mt-6"
          gap={2}
          direction="horizontal"
        >
          <Button onClick={handleRetry}>Try Again</Button>
          {hasMultipleTenants && (
            <LinkButton variant="secondary" to="/organizations">
              Switch Organization
            </LinkButton>
          )}
          {isEluveAdmin && (
            <LinkButton variant="secondary" to="/admin">
              Admin Dashboard
            </LinkButton>
          )}
          <Button
            variant="outline"
            onClick={async () => {
              await Session.signOut();
              navigate('/login');
            }}
          >
            Sign Out
          </Button>
        </Stack>
      </div>
    </main>
  );
};
